export default __webpack_public_path__ + "static/media/journey-header-background-image.003f46d9.png";